import AccountFrame from '../../components/AccountFrame';
import { appForNext } from '../../utils/joinFlow';
import './Join.css';

// THE JOIN FRAME: the account pages' frame (components/AccountFrame), the
// shell's <Onboarding> surface Caliber's own walk wears (owner call 2026-10-04: full screen, flush
// on the dot grid, loud left-aligned fields, no card). One strip of stages for
// the whole join; when the person came from an app, the app is its last stage,
// so the strip runs on into that app's own onboarding.
export const JOIN_STAGES = [
  { id: 'handle', label: 'Handle' },
  { id: 'you', label: 'You' },
  { id: 'photo', label: 'Photo' },
  { id: 'codes', label: 'Recovery' },
];

/** The strip, standing at stage `hereId`. `onSelect(id)` makes the stages
 *  before it pressable (Register's way back to the handle). */
export function joinStages(hereId, next, onSelect) {
  const app = appForNext(next);
  const all = app ? [...JOIN_STAGES, { id: 'app', label: app.name }] : JOIN_STAGES;
  const here = all.findIndex((st) => st.id === hereId);
  return all.map((st, i) => ({
    ...st,
    mark: i < here ? 'kept' : 'open',
    here: i === here,
    onSelect: onSelect && i < here ? () => onSelect(st.id) : undefined,
  }));
}

function JoinFrame({ stages, children }) {
  return <AccountFrame stages={stages} label="Join ofSelf">{children}</AccountFrame>;
}

export default JoinFrame;
